import {Injectable} from "@angular/core";

@Injectable()
export class AdditionalValidationsService {

    private errors:any={};
    private posForm;
    private additionalForm;
    private limitedTollForm;
    private unlimitedTollForm;
    private additionalSelected;
    private showUnlimited;
    private showLimited;

    public validate(additionalSelected, showUnlimited, showLimited, unlimitedTollForm, limitedTollForm,
                    additionalForm, posForm) {

        this.additionalForm = additionalForm;
        this.posForm = posForm;
        this.limitedTollForm = limitedTollForm;
        this.unlimitedTollForm = unlimitedTollForm;
        this.additionalSelected = additionalSelected;
        this.showLimited = showLimited;
        this.showUnlimited =showUnlimited;

        this.errors = {};
        let isValid = true;

        if(!this.validatePOS()){
            isValid=false;
        };

        if (!!this.additionalSelected.addSelected) {
            if (this.additionalSelected.addSelected != 'TOLL') {

                if(!this.validAdditional())
                    isValid = false;

            } else {

                if(!this.validToll())
                    isValid=false;

            }
        } else {
            this.reportError('additionalSelection', {required:true});
            this.errors['additionalSelection'] = {required:true}
            isValid=false;
        }

        return {valid:isValid, errors:this.errors};
    }

    private validatePOS() {
        return this.validateForm(this.posForm);
    }

    private validAdditional() {
        return this.validateForm(this.additionalForm);
    }

    private validToll() {
        if (this.showUnlimited || this.showLimited) {
            let isValid = true;
            let tollConsumeSelected = true;
            if (this.showUnlimited) {
                isValid = this.validUnlimitedToll();
            }
            if (this.showLimited) {
                isValid = this.validLimitedToll();
            }
            return isValid;
        } else {
            this.reportError('tollSelection', {required:true});
            return false;
        }
    }

    private validLimitedToll(){
        return this.validateForm(this.limitedTollForm);
    }

    private validUnlimitedToll() {
        return this.validateForm(this.unlimitedTollForm);
    }

    private validateForm(form) : boolean{
        if(form.valid){
            return true;
        } else {
            this.reportErrors(form);
            return false;
        }
    }

    private reportErrors(form: any) {
        Object.keys(form.controls).forEach((key) => {
            if(!!form.controls[key].errors){
                this.errors[key] = form.controls[key].errors;
            }
        })
    }

    private reportError(key, obj) {
        this.errors[key]=obj;
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional-validations.service.ts